'use client';
import { CatDropdown } from '@blocks-react/components/Dropdown';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { BlocksSelectEvent } from '@blocks-web-components/events/blocks-select';
import { useFormContext } from 'react-hook-form';
import { useDropdownController } from '../../../hooks/form-controllers/useDropdownController';
import { useCallback } from 'react';
import styles from '../DealerLocator.module.scss';
import cx from 'classnames';

export interface DealerLocatorFiltersSortDropdownProps {
  title: string;
  sortingOptions: { value: string; label: string }[];
}

const SORT_ID = 'sortOrder';

export const DealerLocatorFiltersSortDropdown = ({
  title,
  sortingOptions
}: DealerLocatorFiltersSortDropdownProps) => {
  const { watch, setValue } = useFormContext();
  const { dropdownField } = useDropdownController({ name: SORT_ID });

  const value = watch(SORT_ID)?.value || sortingOptions[0]?.value;

  const handleSelect = useCallback(
    (e: BlocksSelectEvent) => {
      const newValue = sortingOptions.find(
        (option) => option.value === e.detail.value
      );
      setValue(SORT_ID, newValue, { shouldDirty: true });
    },
    [sortingOptions, setValue]
  );

  return (
    <div className="my-4">
      <p
        className={cx(
          styles['dealer-locator-text'],
          'cat-u-theme-typography-label-lg mb-0'
        )}
      >
        {title}
      </p>
      <CatDropdown
        {...dropdownField}
        hideLabel
        data-testid="dealer-locator-filters-sort-dropdown"
        value={value}
        size="md"
        onBlSelect={handleSelect}
      >
        <CatList>
          {sortingOptions.map((item) => {
            const isOptionSelected = watch(SORT_ID)?.value === item.value;
            return (
              <CatListItem
                value={item.value}
                key={item.value}
                isActive={isOptionSelected}
              >
                {item.label}
              </CatListItem>
            );
          })}
        </CatList>
      </CatDropdown>
    </div>
  );
};
